import {GeneratorRequest} from "./GeneratorRequest";

const nomApi = "hourly_rates";

export const HourlyRateRepository = {
    gets : GeneratorRequest.gets(nomApi, true),
    put: GeneratorRequest.put(nomApi, true),
    post: GeneratorRequest.post(nomApi, true),
}
